import React from 'react';
import { connect } from 'react-redux';
import { Nav } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';

import PerfectScrollBar from 'react-perfect-scrollbar';

import Profile from '../../components/customer/profile';
import Bank from '../../components/customer/bank';
import Relative from '../../components/customer/relative';
import Security from '../../components/customer/security';

import { ReactComponent as SvgProfile } from '../../assets/img/_profile.svg';
import { ReactComponent as SvgBank } from '../../assets/img/_bank.svg';
import { ReactComponent as SvgRelative } from '../../assets/img/_relative.svg';
import { ReactComponent as SvgSecurity } from '../../assets/img/_security.svg';

import { WebSocketContext } from '../socket/webSocket';
import {
  makeGetToken,
  makeGetCustomerBankAccount,
  makeGetDefaultAccount,
} from '../../lib/selector';

import { v4 as uuidv4 } from 'uuid';
import { profileRequest, bankAccRequest } from './actions';
import { noicapRequest } from '../banggia/actions';
import { translate } from 'react-i18next';

import { isEqual } from 'lodash';

class Customer extends React.Component {
  componentDidMount() {
    this.props.dispatch(noicapRequest());
    const { defaultAccount } = this.props;
    if (defaultAccount) {
      this._handleLoadProfile();
      this._handleLoadBankAccount();
    }
  }

  componentDidUpdate(preProps) {
    const {
      defaultAccount,
      authen: { changeBankSuccessful },
    } = this.props;
    if (defaultAccount && !isEqual(defaultAccount, preProps.defaultAccount)) {
      this._handleLoadProfile();
      this._handleLoadBankAccount();
    }
    if (
      changeBankSuccessful &&
      changeBankSuccessful !== preProps.authen.changeBankSuccessful
    ) {
      this._handleLoadProfile();
      this._handleLoadBankAccount();
    }
  }

  _handleLoadProfile = () => {
    const { token } = this.props;
    if (!token) return;

    const uuid = uuidv4();
    const params = {
      group: 'CORE',
      user: token.user,
      session: token.session,
      cmd: 'GetProfiles',
      rqId: uuid,
      channel: 'WTS',
      data: {
        cif: token.cif,
      },
    };

    this.props.dispatch(profileRequest(params));
  };

  _handleLoadBankAccount = () => {
    const { token, defaultAccount } = this.props;
    if (!defaultAccount) return;

    const uuid = uuidv4();
    const params = {
      group: 'CORE',
      user: token.user,
      session: token.session,
      cmd: 'getBankAcntList',
      rqId: uuid,
      channel: 'WTS',
      data: {
        acntNo: defaultAccount.acntNo,
        subAcntNo: defaultAccount.subAcntNo,
      },
    };

    this.props.dispatch(bankAccRequest(params));
  };

  render() {
    const {
      match: { params },
      token,
      t,
    } = this.props;

    // console.log(token);
    if (!token) return <Redirect to="/" />;
    return (
      <div className="page-asset">
        <div className="page-content d-flex flex-row">
          <PerfectScrollBar>
            <Nav as="ul" className="d-flex flex-column">
              <li
                className="asset-header d-flex align-items-center"
                style={{ width: '319px', borderBottom: '1px solid #535a86' }}
              >
                <span className="ml-2 fz-12 color-half-brown text-uppercase">
                  {`${t('txt-label-profile')} & ${t('txt-label-security')}`}
                </span>
              </li>
              <Nav.Item
                as="li"
                className={params.typeId === 'ho-so' ? 'active' : ''}
              >
                <Link to="ho-so">
                  <SvgProfile />
                  {t('txt-label-profile')}
                </Link>
              </Nav.Item>
              <Nav.Item
                as="li"
                className={params.typeId === 'bank' ? 'active' : ''}
              >
                <Link to="bank">
                  <SvgBank />
                  {t('txt-label-bank-account')}
                </Link>
              </Nav.Item>
              <Nav.Item
                as="li"
                className={params.typeId === 'uy-quyen' ? 'active' : ''}
              >
                <Link to="uy-quyen">
                  <SvgRelative />
                  {t('txt-label-authorization')}
                </Link>
              </Nav.Item>
              <Nav.Item
                as="li"
                className={params.typeId === 'security' ? 'active' : ''}
              >
                <Link to="security">
                  <SvgSecurity />
                  {`${t('txt-pass')} & ${t('txt-xacthuc')}`}
                </Link>
              </Nav.Item>
            </Nav>
          </PerfectScrollBar>
          <div
            className="d-flex flex-column"
            style={{ width: 'calc( 100% - 320px )', height: '100%' }}
          >
            {params.typeId === 'ho-so' ? (
              <Profile />
            ) : params.typeId === 'bank' ? (
              <Bank />
            ) : params.typeId === 'uy-quyen' ? (
              <Relative />
            ) : (
              <Security />
            )}
          </div>
        </div>
      </div>
    );
  }
}

Customer.contextType = WebSocketContext;

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getDefaultAccount = makeGetDefaultAccount();

  const getBankAccount = makeGetCustomerBankAccount();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      defaultAccount: getDefaultAccount(state),
      bankAcc: getBankAccount(state),
      authen: state.authen,
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(Customer)
);
